import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FlashController} from '../../../flash-payment-core/services/flash-controller.service';
import {GlobalService} from '../../../../global.service';

@Component({
  selector: 'app-options-for-payment',
  templateUrl: './options-for-payment.component.html',
  styleUrls: ['../way-to-pay.component.sass']
})
export class OptionsForPaymentComponent implements OnInit {
  @Output() action = new EventEmitter<any>();
  openForm = false;
  showOptionList = true;

  constructor(public flashPaymentService: FlashController, private global: GlobalService) {
  }

  ngOnInit(): void {
    this.flashPaymentService.paymentProcess();
    setTimeout(() => {
      if (!this.flashPaymentService.controller.isPlaceToPayVisible) {
        this.selectForm(0);
      }
    }, 1500)

  }

  selectForm(idForm: number) {
    //this.showOptionList = false;
    this.flashPaymentService.initData();
    if (idForm === 0) {
      setTimeout(() => {
        this.flashPaymentService.controller.useSavedInformation = false;
        this.flashPaymentService.autoFill();
      }, 1500);

      this.flashPaymentService.controller.isCard = true;
      this.flashPaymentService.controller.isACH = false;
      this.flashPaymentService.controller.isPlaceToPay = false;
     //
      if (this.flashPaymentService.controller.tokenCards.length == 0) {
        this.openForm = true;
      }
    } else if (idForm === 1) {
      this.flashPaymentService.controller.isCard = false;
      this.flashPaymentService.controller.isACH = true;
      this.flashPaymentService.controller.isPlaceToPay = false;
    } else {
      this.flashPaymentService.controller.isACH = false;
      this.flashPaymentService.controller.isCard = false;
      this.flashPaymentService.controller.isPlaceToPay = true;
    }

    this.action.emit({
        openForm: this.openForm,
        // showOptionList: this.showOptionList
      }
    )
  }

  selectOption(event) {
    console.log(event);
    if (this.flashPaymentService.controller.isCardVisible &&
        this.flashPaymentService.controller.isPlaceToPayVisible &&
        this.flashPaymentService.controller.isACHVisible) {
        if (event === 0) {
          this.selectForm(event);
        } else if (event === 1) {
          this.selectForm(2);
        } else {
          this.selectForm(1);
        }
    } else if (
      this.flashPaymentService.controller.isCardVisible &&
      this.flashPaymentService.controller.isACHVisible &&
      !this.flashPaymentService.controller.isPlaceToPayVisible
    ) {
      if (event === 0) {
        this.selectForm(event);
      } else if (event === 1) {
        this.selectForm(1);
      }
    } else if ( this.flashPaymentService.controller.isCardVisible &&
      !this.flashPaymentService.controller.isACHVisible &&
      this.flashPaymentService.controller.isPlaceToPayVisible) {
      if (event === 0) {
        this.selectForm(event);
      } else if (event === 1) {
        this.selectForm(2);
      }
    } else {
      if (event === 0) {
        this.selectForm(1);
      } else {
        this.selectForm(2);
      }
    }
  }
}
